import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
export const useSafeSelector = selector => {
  if (!selector) {
    throw new Error(`You must pass a selector to useSelector`);
  }
  if (typeof selector !== 'function') {
    throw new Error(`You must pass a function as a selector to useSelector`);
  }
  const contextValue = useContext(ReactReduxContext);
  if (contextValue) {
    const currentState = contextValue.store.getState();
    return selector(currentState);
  }
};